import React, { useEffect, useState, FC, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Accordion,Checkbox, Card, Tabs, Button, Modal,IconBriefcaseWithBuckle } from "@veneer/core";
import { redirect, useNavigate, useSearchParams } from "react-router-dom";
import {
  resetFormShippingAddressData,
  setShippingAddressFormValidity,
} from "@store/reducers/form-equipment-physical-shipping-address-slice";
import { useAppSelector, useAppDispatch } from "@store/hooks";

import type { RootState } from "@store/store";

import {
  resetFormAlternateData,
  setFormAlternateValidity,
} from "@store/reducers/form-contact-alternate-slice";
import {
  resetFormPartShippingAddressData,
  setPartShippingAddressFormValidity,
} from "@store/reducers/form-part-shipping-address-slice";

import {
  fetchCaseInfo,
  fetchProductInfo,
  fetchAndProcessCaseInfo,
} from "@store/reducers/create-case-apis";
import {
  resetFormCaseData,
  setFormData,
} from "@store/actions/case-deatis-form-actions";

import {
  alternateContactInformation,
  FileData,
  PartShippingaddressAddress,
  submitFormRef,
} from "@constants/case-create";

import CaseItems from "@components/home-page/shared-components/case-items/case-items";

import CaseDetails from "./case-details/case-details";
import CaseAddress from "./case-address/case-address";
import CaseContact from "./case-contact/case-contact";

import {
  GET_TERADICI_PRODUCT_ID,
  POST_CREATE_CASE,
  POST_UPLOAD_ATTACHMENTS,
  POST_UPLOAD_LOG_ATTACHMENTS,
} from "@constants/end-points";
import {
  apiGet,
  apiGetWithHeader,
  apiPost,
  apiPostUploadFiles,
} from "@services/service";
import { setLoading } from "@store/reducers/loadingSlice";

import { toast } from "react-toastify";

import { resetFormPrimaryData } from "@store/reducers/form-contact-primary-slice";

import "./create-case.scss";
import { validateAddress } from "utils";
import { Trans, useTranslation } from "react-i18next";
import CaseDisclaimer from "../home-page/shared-components/case-items/case-disclaimer";

interface CaseDetailsRef {
  submitForm: () => any;
}

type ObjType = { [key: string]: any };

const CreateCase: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const caseDetailsChildRef = useRef<CaseDetailsRef>(null);
  const [customerAvailabilityData, setCustomerAvailabilityData] = useState<any>(
    {
      preferredContactMethod: "",
      AvailabilityDate: "",
      bestTimeToContact: "",
    },
  );
  console.log(customerAvailabilityData,"customerAvailabilityData");

  const caseContactChildRef = useRef<submitFormRef>(null);
  const caseAddressRef = useRef<CaseDetailsRef>(null);
  const topperRef = useRef<HTMLDivElement | null>(null);
  const { savedContactsDropDown, countryList } = useAppSelector(
    (state: RootState) => state.createCaseAPI
  );

  const [openDisclaimer, setOpenDisclaimer] = useState(false);
  const [disclaimerData, setDisclaimerData] = useState({
  consentValue: "No",
  osConsentValue: "No"
});
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const caseDetailsFormData = useAppSelector(
    (state: RootState) => state.caseDetailsform.formData
  );
console.log(caseDetailsFormData,"xyz",caseDetailsFormData.ProblemDescription,disclaimerData.consentValue,disclaimerData.osConsentValue)
  const caseInfo = useAppSelector((state) => state.createCaseAPI.caseInfo);
  
//   const customerAvailability = useAppSelector(
//   (state: RootState) => state.customerAvailability
// );
  const { countryCodes } = useAppSelector(
    (state: RootState) => state.createCaseAPI
  );

  const { productInfo, loading, error, shippingaddressdetails } =
    useAppSelector((state: RootState) => state.createCaseAPI);

  const formShippingAddressData = useAppSelector(
    (state) => state.formShippingAddressInfo.formShippingAddressData
  );
  const formPartShippingAddressData = useAppSelector(
    (state) => state.formPartShippingAddressInfo.formPartShippingAddressData
  );

  const { formPrimaryData } = useAppSelector(
    (state) => state.formContactPrimaryInfo
  );
  const { formAlternateData } = useAppSelector(
    (state) => state.formContactAlternateInfo
  );

  const [activeAccordian, setActiveAccordian] = useState(0);

  const [totalUploadFiles, setTotalUploadFiles] = React.useState<FileData[]>(
    []
  );
  const [totalLogUploadFiles, setTotalLogUploadFiles] = React.useState<
    FileData[]
  >([]);
  const [isAddressValidatedParent, setIsAddressValidatedParent] = useState(true);
  const [isCountryValidationRequired, setIsCountryValidationRequired] = useState(false);
  const [disclaimerAllowSubmit, setDisclaimerAllowSubmit] = useState(false);
  
  const totalTabs = 2;

  const fetchData = async (ProductNumberEditPage: any) => {
    return await validateAddress(ProductNumberEditPage);
  };

  useEffect(() => {
       // redirect to home if required params are missing
    
    const hasAnyRequiredParam =
      searchParams.has("pinfo") ||
      searchParams.has("pno") ||
      searchParams.has("ainfo");
      if (!hasAnyRequiredParam) {
      navigate("/");
    }
    const subject = searchParams.get("subject") || [""];
    const description = searchParams.get("description") || "";
    const wizardrslt = searchParams.get("wizardrslt") || "";
    const pinfo = searchParams.get("pinfo");
    const updateFormData = async () => {
      let ISTeradeciCall: boolean = subject !== "";

      if (searchParams.has("pinfo")) {
        try {
          ISTeradeciCall = (await fetchData(pinfo)) ?? false;
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }

      dispatch(
        setFormData({
          ...caseDetailsFormData,
          ISTeradeciCall,
          CaseSubject: subject,
          ProblemDescription: description,
          TroubleshootingStepsTaken: wizardrslt,
        })
      );
    };

    updateFormData();
    let payload = {
      contactid: "85680c15-7814-e711-80fc-5065f38ad971",
      accountid: "f16eeb64-73fc-e611-80fa-5065f38ad971",
    };

    const productPayload = {
      ainfo: searchParams.get("ainfo"),
      pinfo: searchParams.get("pinfo"),
      pno: searchParams.get("pno"),
      contactid: "85680C15-7814-E711-80FC-5065F38AD971",
    };

    dispatch(fetchCaseInfo(payload));
    dispatch(fetchProductInfo(productPayload));
  }, [dispatch]);

  useEffect(() => {
    if (caseInfo) {
      const isValid = true;
      dispatch(
        setFormData({
          ...caseDetailsFormData,
          CasePriority: [caseInfo.selectedcasepriority?.Key],
        })
      );
      dispatch(
        setFormAlternateValidity({
          isValid,
          formData: alternateContactInformation,
        })
      );
      dispatch(
        setShippingAddressFormValidity({
          isValid: !isValid,
          formData: shippingaddressdetails,
        })
      );

      dispatch(
        setPartShippingAddressFormValidity({
          isValid,
          formData: PartShippingaddressAddress,
        })
      );

      dispatch(fetchAndProcessCaseInfo());
      const langShortCode: string = caseInfo?.Contactsdata?.[0]?.LangShortCode;
      if (langShortCode === "" || langShortCode === null || langShortCode === undefined || langShortCode.toLowerCase() === "no") {
        toast.error(
          t('HPI.ErrorMessage.langShortCodeError', { defaultValue: 'Please update your language in Profile & Settings' })
        );
        // navigate("/profile");
      }
      return () => {
        // Reset form data when component unmounts
        dispatch(resetFormCaseData());
        dispatch(resetFormPrimaryData());
        dispatch(resetFormAlternateData());
        dispatch(resetFormPartShippingAddressData());
        dispatch(resetFormShippingAddressData());
      };
    }
  }, [caseInfo]);

  const changeTabHandler = (id: any) => {
    if (id < activeAccordian) {
      setActiveAccordian(id);
    } else {
      handleNextClick(false);
    }
  };

  const isDisabled = () => {
    return false;
  };

  const scrollTo = () => {
     if (topperRef.current) {
    topperRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
  }

  const handleNextClick = (allowSubmit: boolean) => {
    if (caseDetailsChildRef.current && activeAccordian === 0) {
      
      if (caseContactChildRef.current) {
        const isValid = caseContactChildRef.current.submitForm().isValid;
        const isValidCaseDetail: any = caseDetailsChildRef.current.submitForm().isValid;
        if (isValid && isValidCaseDetail) {
          console.log(
            "case Contact Child Ref Form is valid! Proceeding with submission..."
          );
          scrollTo();
          handleFormSubmit();
        } else {
          toast.error(
            caseContactChildRef.current.submitForm().errorText ||
            t('HPI.ErrorMessage.FillRequiredFields', { defaultValue: 'Please fill the required fields' })
          );
        }
      }
    }
    if( caseAddressRef.current && activeAccordian === 1){

    if (caseAddressRef.current) {
      const isValid = caseAddressRef.current.submitForm();
      if (isValid) {
        console.log(
          "case Address Ref Form is valid! Proceeding with submission..."
        );
        setOpenDisclaimer(true);
        if(allowSubmit){
          scrollTo();
          genaratePayload();
        }
        
      } else {
        toast.error(t('HPI.ErrorMessage.FillRequiredFields', { defaultValue: 'Please fill the required fields' }));
      }
    }
    }
  };
  
  const genaratePayload = () => {
    
    const storedProductSeries = sessionStorage.getItem("Productseries");
    let adpdata = sessionStorage.getItem("isADP") === "true" ? {
      "IsADPCoverage": caseDetailsFormData.IsADPCoverage || "No",
      "dateOfIncident": caseDetailsFormData.dateOfIncident || "",
      "AccidentOccur": caseDetailsFormData.AccidentOccur || "",
      "ConditionsDamage": caseDetailsFormData.ConditionsDamage || "",
      "ProblemDescription": caseDetailsFormData.ProblemDescription || "",
      "ConsentAcknowledgement": disclaimerData.consentValue,
      "OSReinstallationConsent": disclaimerData.osConsentValue
    } : {
        "ProblemDescription": caseDetailsFormData.ProblemDescription || "",
        "ConsentAcknowledgement": disclaimerData.consentValue,
        "OSReinstallationConsent": disclaimerData.osConsentValue
      };
    let requestCreatCasePayload = {
      contactid: "85680c15-7814-e711-80fc-5065f38ad971",
      createcase: {
        Adpvalue: caseDetailsFormData.Adpvalue,
        IsADPCoverage: caseDetailsFormData.IsADPCoverage || "No",
        dateOfIncident: caseDetailsFormData.dateOfIncident ||"",
        AccidentOccur: caseDetailsFormData.AccidentOccur || "",
        ConditionsDamage: caseDetailsFormData.ConditionsDamage || "",
        CaseSubject: caseDetailsFormData.CaseSubject?.[0] || "-1",
        CasePriority: caseDetailsFormData.CasePriority?.[0],
        WhatKindOfAccidentOccured:
          caseDetailsFormData.WhatKindOfAccidentOccured?.[0] || "-1",
        CaseApplicationInformation:
          caseDetailsFormData.CaseApplicationInformation?.[0] || "-1",
        ApplicationInformationVersion:
          caseDetailsFormData.ApplicationInformationVersion?.[0] || "-1",
        ApplicationInformationVersiontext:
          caseDetailsFormData.ApplicationInformationVersionText,
        OperatingSystem: caseDetailsFormData.OperatingSystem?.[0] || "-1",
        OperatingSystemVersion:
          caseDetailsFormData.OperatingSystemVersion?.[0] || "-1",
        CustomerTrackingNumber: caseDetailsFormData.CustomerTrackingNumber,
        ErrorCodes: caseDetailsFormData.ErrorCodes,
        IssueDescription: caseDetailsFormData.IssueDescription,
        TroubleshootingStepsTaken:
          caseDetailsFormData.TroubleshootingStepsTaken,
        primarysubmitterscontact: (formPrimaryData.UserId || "").toString(),
        alternatesubmittercontact: (
          formAlternateData.UserId || "-1"
        ).toString(),
        equipmentsubmitterscontact: (
          formShippingAddressData.UserId || "-1"
        ).toString(),
        shippingsubmitterscontact: (
          formPartShippingAddressData.UserId || "-1"
        ).toString(),
        BindingPin: (formShippingAddressData?.BindingPin || "").toString(),
        addsavedcontacts: formPrimaryData.addsavedcontacts,
        alternateaddsavedcontacts: formAlternateData.alternateaddsavedcontacts,

        selectedaccount: formShippingAddressData.SiteName?.[0],

        showparts: formShippingAddressData?.showparts,
        SoftwareRelease: caseDetailsFormData.SoftwareRelease,

        Productseries: storedProductSeries ? JSON.parse(storedProductSeries) : "",
        Version: sessionStorage.getItem("Version") || "",

        licenseKey: sessionStorage.getItem("licenseKey") || "",
        IsRMA: caseDetailsFormData.IsRMA === "no" ? "0" : "1",

        PrimaryContactInformation: {
          UserId: formPrimaryData.UserId?.[0],
          AccountId: formPrimaryData.AccountId,
          fullname: formPrimaryData.fullname,
          FirstName: formPrimaryData.FirstName,
          LastName: formPrimaryData.LastName,
          PhoneNumber: formPrimaryData.PhoneNumber,
          Extension: formPrimaryData.Extension,
          AlternatePhoneNumber: formPrimaryData.AlternatePhoneNumber,
          AlternateExtension: formPrimaryData.AlternateExtension,
          Email: formPrimaryData.Email,
          countryName: formPrimaryData.countryName,
          cpf: formPrimaryData.cpf,
          neighbourhood: formPrimaryData.neighbourhood,
          stateInscription: formPrimaryData.stateInscription,
          countryId: formPrimaryData.countryId?.[0],
          accountType: formPrimaryData.accountType,
          phNumCountryCode: formPrimaryData.phNumCountryCode?.[0],
          phNumAlternateCountryCode:
            formPrimaryData.phNumAlternateCountryCode?.[0],
        },
        AlternateContactInformation: {
          FirstName: formAlternateData.FirstName,
          LastName: formAlternateData.LastName,
          PhoneNumber: formAlternateData.PhoneNumber,
          Extension: formAlternateData.Extension,
          AlternatePhoneNumber: formAlternateData.AlternatePhoneNumber,
          AlternateExtension: formAlternateData.AlternateExtension,
          Email: formAlternateData.Email,

          countryId: formAlternateData.countryId?.[0],
          countryName: formAlternateData.countryName?.[0],
          cpf: (formAlternateData.cpf || "").toString(),
          neighbourhood: (formAlternateData.neighbourhood || "").toString(),
          stateInscription: (formAlternateData.stateInscription || "").toString(),

          phNumCountryCode: formAlternateData.phNumCountryCode?.[0],
          phNumAlternateCountryCode:
            formAlternateData.phNumAlternateCountryCode?.[0],
        },
        EquipmentPhysicalAddress: {
          UserId: formShippingAddressData.UserId?.[0],
          AccountId: formShippingAddressData.AccountId,
          fullname: formShippingAddressData.fullname,
          FirstName: formShippingAddressData.FirstName,
          LastName: formShippingAddressData.LastName,
          PhoneNumber: formShippingAddressData.PhoneNumber,
          Extension: formShippingAddressData.Extension,
          AlternatePhoneNumber: formShippingAddressData.AlternatePhoneNumber,
          AlternateExtension: formShippingAddressData.AlternateExtension,
          Email: formShippingAddressData.Email,
          countryName: formShippingAddressData.countryName,

          cpf: (formPrimaryData.cpf || "").toString(),
          neighbourhood: (formPrimaryData.neighbourhood || "").toString(),
          stateInscription: (formPrimaryData.stateInscription || "").toString(),
          
          countryId: formShippingAddressData.contactCountryId?.[0],
          accountType: formShippingAddressData.showparts,
          phNumCountryCode: formShippingAddressData.phNumCountryCode?.[0],
          phNumAlternateCountryCode:
            formShippingAddressData.phNumAlternateCountryCode?.[0],
        },
        shippingaddress: {
          fullname: formShippingAddressData.fullname,
          contactphone: formShippingAddressData.contactphone,
          company: formShippingAddressData.company,
          Mailstop: formShippingAddressData.Mailstop,
          country: formShippingAddressData.countryId[0],
          AddressLine1: formShippingAddressData.AddressLine1,
          AddressLine2: formShippingAddressData.AddressLine2,
          AddressLine3: formShippingAddressData.AddressLine3,
          City: formShippingAddressData.City,
          State: formShippingAddressData.State,
          ZipCode: formShippingAddressData.ZipCode,
        },

        PartsShippingAddress: {

          AccountId: formPartShippingAddressData.AccountId,
          countrycode: formPartShippingAddressData.countrycode,
          countryId: formPartShippingAddressData.countryId?.[0],
          countryName: formPartShippingAddressData.countryName,
          countryshortcode: formPartShippingAddressData.countryshortcode,

          cpf: formPartShippingAddressData.cpf,
          fullname: formPartShippingAddressData.fullname,
          neighbourhood: formPartShippingAddressData.neighbourhood,
          stateInscription: formPartShippingAddressData.stateInscription,

          FirstName: formPartShippingAddressData.FirstName,
          LastName: formPartShippingAddressData.LastName,
          PhoneNumber: formPartShippingAddressData.PhoneNumber,
          Extension: formPartShippingAddressData.Extension,
          AlternatePhoneNumber: formPartShippingAddressData.AlternatePhoneNumber,
          AlternateExtension: formPartShippingAddressData.AlternatePhoneNumber,
          Email: formPartShippingAddressData.Email,
          TaxId: formPartShippingAddressData.TaxId,
          TaxOfficeName: formPartShippingAddressData.TaxOfficeName,
          phNumCountryCode: formPartShippingAddressData.phNumCountryCode?.[0] || "-1",
        },
        shippingpartaddress: {
          AddressLine1: formPartShippingAddressData.AddressLine1,
          AddressLine2: formPartShippingAddressData.AddressLine2,
          AddressLine3: formPartShippingAddressData.AddressLine3,
          City: formPartShippingAddressData.City,
          company: formPartShippingAddressData.company,
          country: formPartShippingAddressData.countryId?.[0] || "-1",
          Mailstop: formPartShippingAddressData.Mailstop,
          State: formPartShippingAddressData.State,
          ZipCode: formPartShippingAddressData.ZipCode,
        },
        deaultValue: formShippingAddressData.company,
        confirm: true,
      },
      customeravailability: {
        ContactMethods: customerAvailabilityData.preferredContactMethod,
        TimeToContact: customerAvailabilityData.bestTimeToContact,
        AvailableDate: customerAvailabilityData.availabilityDate,
      },
      pinfo: searchParams.get("pinfo"),
      assetid: searchParams.get("assetid"),
      ainfo: searchParams.get("ainfo"),
      pno: searchParams.get("pno"),

      neighbourhood: (formPrimaryData.neighbourhood || "").toString(),
      CPF_CNPJ: (formPrimaryData.cpf || "").toString(),
      StateInscription: (formPrimaryData.stateInscription || "").toString(),

      countryName: formPrimaryData?.countryName,

      phNumCountryCode: getCountryCode(
        formPrimaryData?.countryId?.[0],
        countryCodes
      ),
      phNumAlternateCountryCode: getCountryCode(
        formPrimaryData?.phNumAlternateCountryCode?.[0],
        countryCodes
      ),

      altPhNumAlternateCountryCode: getCountryCode(
        formAlternateData?.countryId?.[0],
        countryCodes
      ),
      altinfPhNumAlternateCountryCode: getCountryCode(
        formAlternateData?.phNumAlternateCountryCode?.[0],
        countryCodes
      ),

      equipmentPhNumCountryCode: getCountryCode(
        formShippingAddressData?.countryId?.[0],
        countryCodes
      ),
      partsPhNumCountryCode: getCountryCode(
        formPartShippingAddressData?.countryId?.[0],
        countryCodes
      ),

      equipmentCountry:  (formShippingAddressData?.countryId?.[0]).toString(),

      equipmentTaxId: (
        formShippingAddressData?.equipmentTaxId || ""
      ).toString(),
      equipmentTaxOfficeName: (
        formShippingAddressData?.equipmentTaxOfficeName || ""
      ).toString(),

      partsShippingCountry: (
        formPartShippingAddressData?.partsShippingCountry || "-1"
      ).toString(),
      partsShippingTaxId: (
        formPartShippingAddressData?.partsShippingTaxId || ""
      ).toString(),
      partsShippingTaxOfficeName: (
        formPartShippingAddressData?.partsShippingTaxOfficeName || ""
      ).toString(),

    };

    if (caseDetailsFormData?.ProblemDescription?.length || adpdata) {
      //const createcase = { ...requestCreatCasePayload.createcase, ProblemDescription: caseDetailsFormData.ProblemDescription }
      const createcase = { ...requestCreatCasePayload.createcase, ProblemDescription: adpdata };
      requestCreatCasePayload = { ...requestCreatCasePayload, createcase }
    }
    createCaseAPIHandler(requestCreatCasePayload);
  };

  const getCountryCode = (
    countryId: string | undefined,
    countryCodes: { value: string; CountryCode: string }[]
  ): string => {
    if (!countryId) return "";

    return countryCodes
      .filter((val) => val.value === countryId)
      .map((val) => val.CountryCode.replace("+", ""))
      .join(",");
  };

  const uploadFiles = async (caseID: string): Promise<any> => {
    try {
      if (!totalUploadFiles.length) {
        console.log("No files to upload");
        return true;
      }
      let isPoly = sessionStorage.getItem("isPoly") ?? "false";
      const formData = new FormData();
      formData.append("caseid", caseID);
      formData.append("isPolyCheck", isPoly);
      totalUploadFiles.forEach((file: any, index: any) => {
        formData.append(`uploadedfile_${index + 1}`, file.file);
      });
      try {
        const response = await apiPostUploadFiles(
          POST_UPLOAD_ATTACHMENTS,
          formData
        );
        setTotalUploadFiles([]);
        console.log("File uploaded successfully:", response.data);
        dispatch(setLoading(false));
        return true;
      } catch (error) {
        console.error("Error uploading file:", error);
        dispatch(setLoading(false));
        return false;
      }
    } catch (error) {
      console.error("File Upload Error:");
      dispatch(setLoading(false));
      return false;
    }
  };

  const uploadLogFiles = async (caseID: string): Promise<any> => {
    try {
      if (!totalUploadFiles.length) {
        console.log("No files to upload");
        return true;
      }
      let isPoly = sessionStorage.getItem("isPoly") ?? "false";
      const formData = new FormData();
      formData.append("caseid", caseID);
      formData.append("isPolyCheck", isPoly);
      totalLogUploadFiles.forEach((file: any, index: any) => {
        formData.append(`uploadedfile_${index + 1}`, file.file);
      });
      try {
        const response = await apiPostUploadFiles(
          POST_UPLOAD_LOG_ATTACHMENTS,
          formData
        );
        setTotalLogUploadFiles([]);
        console.log("File uploaded successfully:", response.data);
        dispatch(setLoading(false));
        return true;
      } catch (error) {
        console.error("Error uploading file:", error);
        dispatch(setLoading(false));
        return false;
      }
    } catch (error) {
      console.error("File Upload Error:");
      dispatch(setLoading(false));
      return false;
    }
  };

  const createCaseAPIHandler = async (payload: any) => {
    try {
      dispatch(setLoading(true));
      const createCase: any = await apiPost(POST_CREATE_CASE, payload);

      if (searchParams.has("subject")) {
        await uploadLogFiles(createCase.data.CaseId);
      }

      if (createCase?.data?.successmessage) {
        const uploadSuccess = await uploadFiles(createCase.data.CaseId);

        let uri = `cid=${createCase.data.CaseId}`;
        sessionStorage.removeItem("Productseries");
        sessionStorage.removeItem("Version");
        sessionStorage.removeItem("isADP");

        if (uploadSuccess) {
          //toast.success(`${createCase.data.successmessage}`);
          toast.success(t('HPI.Success.CaseSubmitted', { defaultValue: 'Case successfully submitted' }));
          const warnings = createCase?.data?.contactwarningmessages;
          if (warnings) {
            if (warnings.PrimayContactWarning) {
              toast.warning(`Primary Contact Warning: ${warnings.PrimayContactWarning}`);
            }
            if (warnings.AlternateContactWarning) {
              toast.warning(`Alternate Contact Warning: ${warnings.AlternateContactWarning}`);
            }
            if (warnings.EquipContactWarning) {
              toast.warning(`Equipment Contact Warning: ${warnings.EquipContactWarning}`);
            }
            if (warnings.ShippingContactWarning) {
              toast.warning(`Shipping Contact Warning: ${warnings.ShippingContactWarning}`);
            }
          }
          dispatch(setLoading(false));
          localStorage.setItem("isPopup", "open");
          navigate(`/edit-case?${uri}`, {
            state: { incidentid: createCase.data.CaseId },
          });

        } else {
          dispatch(setLoading(false));
          console.log("Files upload failed");
          toast.warning(`Case created but file upload failed`);
          navigate(`/edit-case?${uri}`, {
            state: { incidentid: createCase.data.CaseId },
          });
        }
      } else {
        dispatch(setLoading(false));
        toast.error(createCase.message || createCase.Message);
      }
    } catch (error) {
      dispatch(setLoading(false));
      toast.warning("Error creating case:");
    }
  };

  const handleFormSubmit = () => {
    setActiveAccordian((prevTab) => Math.min(prevTab + 1, totalTabs - 1));
  };

  const handleCancel = () => {
    navigate("/");
  };

  return (
    <>
      <Container fluid className="bg-container">
        <div className="create-case-container">
          <div className="header">
            <h2>
              {t("HPI.CreateCase.CaseCreation", {
                defaultValue: "Case creation",
              })}
            </h2>
            <div className="supporting-text col">
              <p>
                {t("HPI.CreateCase.HPsupportCenter", {
                  defaultValue:
                    "Please provide as much information below to help HP Support Center solve your case.",
                })}
              </p>
              <span>
                <strong className="error">*</strong>&nbsp;
                {t("HPI.CreateCase.requiredFields", {
                  defaultvalue: "Required fields",
                })}
              </span>
            </div>
          </div>
          <Card
            border="none"
            background="transparent"
            className="no-bc"
            content={
              <>
                <Container className="card-container case-item">
                  <Row>
                    <CaseItems data={productInfo} />
                  </Row>
                </Container>
                <Container className="card-container no-bg">
                  <Row ref={topperRef} className="Topper">
                    <Col className="detail-container">
                      <Tabs
                        controlId="default"
                        type="attached"
                        onChangeTab={changeTabHandler}
                        selectedTabId={activeAccordian}
                        tabs={[
                          {
                            id: 0,
                            label: t('HPI.CreateCase.CaseDetails', { defaultValue: 'Case information' }),
                            content: (
                              <>
                                <CaseDetails
                                  ref={caseDetailsChildRef}
                                  uploadFiles={totalUploadFiles}
                                  logUploadFiles={totalLogUploadFiles}
                                  onFormSubmit={(
                                    fileData: any,
                                    logFileData: any
                                  ) => {
                                    // handleFormSubmit();
                                    setTotalUploadFiles(fileData);
                                    setTotalLogUploadFiles(logFileData);
                                  }}
                                />
                                <Row className="gx-0">
                                  <Col>
                                    <div className="section-card">
                                      <CaseContact ref={caseContactChildRef} />
                                    </div>
                                  </Col>
                                </Row>
                              </>
                            ),
                            disabled: isDisabled(),
                          },
                          // {
                          //   id: 1,
                          //   label: t('HPI.CreateCase.ContactDetails',{defaultValue:'Contact details'}),
                          //   content: (
                          //   ),
                          //   disabled: isDisabled(),
                          // },
                          {
                            id: 1,
                            label: t('HPI.CreateCase.AddressDetails', { defaultValue: 'Equipment details' }),
                            content: (
                              <>
                                <CaseAddress
                                  ref={caseAddressRef}
                                  productInfo={productInfo}
                                  onAddressValidationChange={(
                                    isValidated,
                                    contryEnable,
                                  ) => {
                                    setIsAddressValidatedParent(isValidated);

                                    setIsCountryValidationRequired(
                                      contryEnable,
                                    );
                                  }}
                                  onCustomerAvailabilityChange={(
                                    data,
                                  ) => {
                                    setCustomerAvailabilityData(data);
                                  }}
                                />
                              </>
                            ),
                            disabled: isDisabled(),
                          },
                        ]}
                      />
                    </Col>
                  </Row>
                </Container>
                <Container className="card-container no-bg">
                  <Row>
                    <div className="container-fluid footer">
                      <div className="row justify-content-lg-between">
                        <div className="col-md-12 col-lg-7 mb-3 left-sec">
                          <p dangerouslySetInnerHTML={{ __html: t('HpPrivacyStatementLink', { defaultValue: `<p>By completing and submitting this form you consent to the use of your data in accordance with HP's Privacy statement.&nbsp;<a target=\"_blank\" href=\"http://www8.hp.com/us/en/privacy/privacy.html\">Learn more about HP's privacy policy</a></p>` }) }}>

                          </p>
                        </div>
                        <div className="button-container col-md-12 col-lg-3 ">
                          <Button
                            id="btn-cancel"
                            appearance="secondary"
                            onClick={handleCancel}
                          >
                            {t("HPI.Cancel", { defaultValue: "Cancel" })}
                          </Button>
                          <Button
                            type="button"
                            id="btn-next"
                            onClick={() => { handleNextClick(false);}}
                            disabled={ activeAccordian === 1 &&
                            isCountryValidationRequired &&
                            !isAddressValidatedParent
                              }
                          >
                            {activeAccordian === 1
                              ? t('HPI.CreateCase.btnSubmitCase', { defaultValue: 'Submit' })
                              : t('HPI.CreateCase.Next', { defaultValue: 'Next' })}
                          </Button>
                          <Modal
                            align="start"
                            closeButton
                            id="disclaimer-modal-id"
                            show={openDisclaimer}
                            onClose={() => setOpenDisclaimer(false)}
                            title={t("HPI.CreateCase.DisclaimerAndConsent", { defaultValue: "Disclaimer & Consent" })}
                            footer={
                              <>
                                <div className="d-flex justify-content-end w-100 gap-2 flex-wrap">
                                  <Button appearance="secondary"
                                    onClick={() => setOpenDisclaimer(false)}>{t("HPI.Cancel", { defaultValue: "Cancel" })}</Button>
                                  <Button
                                    disabled={!disclaimerAllowSubmit}
                                    onClick={() => { setOpenDisclaimer(false); handleNextClick(true); }}
                                  >{t("HPI.CreateCase.AcceptAndSubmit", { defaultValue: "Accept & Submit" })}</Button>
                                </div>
                              </>
                            }
                            alignFooter="end"
                          >
                            <CaseDisclaimer 
                              adpValue={caseDetailsFormData.Adpvalue} 
                              isADP={sessionStorage.getItem("isADP")}
                              onChange={(data) => {
                            setDisclaimerAllowSubmit(data.allowSubmit);
                            setDisclaimerData({
                             consentValue: data.consentValue,
                              osConsentValue: data.osConsentValue
                              });
                            }}
                              isOpen={openDisclaimer}
                            />
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </Row>
                </Container>
              </>
            }
          />
        </div>
      </Container>
    </>
  );
};

export default CreateCase;
